<template>
  <div class="text-center pa-4">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card class="mx-auto" width="100%" elevation="8">
        <!-- TÍTULO CON COLOR E ICONO -->
        <v-card-title
          class="text-h6 d-flex align-center"
          style="background-color: #194c9b; color: white"
        >
          <v-icon class="mr-2">mdi-key-plus</v-icon>
          {{ $t("titulo_modal_rol") }}
        </v-card-title>

        <!-- SUBTÍTULO OPCIONAL -->
        <v-card-subtitle class="pl-4 pt-2">
          {{ $t("subtitulo_modal_rol") }}
        </v-card-subtitle>

        <!-- CONTENIDO -->
        <v-card-text>
          <p>
            <strong>{{ $t("username") }}:</strong> {{ userName }}
          </p>
          <p>
            <strong>{{ $t("rol_actual") }}:</strong>
            <v-chip
              v-if="user.role"
              class="ma-2"
              :color="roleBadgeClass(userRol)"
            >
              {{ userRol }}
            </v-chip>
            <v-chip v-else> Sin Rol </v-chip>
          </p>

          <v-divider></v-divider>

          &nbsp;

          <v-select
            v-model="model"
            :items="items"
            item-title="name"
            item-value="id"
            label="Selecciona un rol para el usuario"
          />
        </v-card-text>

        <!-- BOTONES / ACCIONES -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="closeDialog">Cerrar</v-btn>
          <v-btn color="primary" @click="setRoleUser(userID, model)"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { swal } from "@/utils/swal";
import { getRolesGroups, postRoleUser } from "@/api/usuarios";
import { useSettingsStore } from "@/stores/settings";

export default {
  name: "ModalesRoles",
  props: {
    modelValue: { type: Boolean, default: false },
    user: { type: Object, required: true },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      items: [],
      model: "",
    };
  },
  async mounted() {
    await this.getGroups();
  },

  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    userName() {
      return this.user?.username;
    },
    userRol() {
      //console.log("SS", this.user.role);
      return this.user?.role;
    },
    userEmail() {
      return this.user?.email;
    },
    userID() {
      return this.user?.id;
    },
  },
  methods: {
    roleBadgeClass(role) {
      switch (role) {
        case "Admin QA":
          return "primary";
        case "Owner QA":
          return "warning";
        case "Tester QA":
          return "success";
        default:
          return "econdary";
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    async getGroups() {
      const res = await getRolesGroups();
      this.items = res;
    },
    async setRoleUser() {
      try {
        const userId = this.user?.id;
        const roleId = this.model;
        const roleName =
          this.items.find((r) => r.id === this.model)?.name || this.model;
        if (!userId || !roleId) return;

        const resp = await postRoleUser(userId, roleId);
        //console.log(resp)
        if (resp.message != "Rol asignado correctamente") {
          this.dialog = false;
          this.$emit("roles-updated");

          await swal({
            icon: "error",
            title: this.$t("error"),
            text: resp,
            customClass: {
              popup: this.isDark ? "mi-popup" : "mi-popup-2",
              title: "mi-titulo",
            },
          });

          if (resp == 403) {
            this.dialog = false;
            this.$emit("roles-updated");

            await swal({
              icon: "error",
              title: this.$t("error"),
              text: this.$t("admin_role_permission_error"),
              customClass: {
                popup: this.isDark ? "mi-popup" : "mi-popup-2",
                title: "mi-titulo",
              },
            });
          }
        } else {
          this.dialog = false;
          this.$emit("roles-updated");

         await swal({
            icon: "success",
            title: this.$t("role_assigned"),
            text: this.$t("role_assigned_user", {
              role: roleName,
              user: this.userName,
            }),
            timer: 2500,
            showConfirmButton: false,
            customClass: {
              popup: this.isDark ? "mi-popup" : "mi-popup-2",
              title: "mi-titulo",
            },
          });
        }
      } catch (e) {
        this.dialog = false;
        await swal({
          icon: "error",
          title: this.$t("error"),
          text: this.$t("role_assign_error"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      }
    },
  },
};
</script>
